import React, { useEffect } from "react";
import PublicHome from "../../core/PublicHome/PublicHome";
import "./Logout.scss";
import { useDispatch } from "react-redux";
import allActions from "../../../redux/actions";
import { removeSingleCookie } from "../../../cookieHelper";

const Logout = (props: any) => {
  const uId: any = sessionStorage.getItem('leuId');
  const dispatch = useDispatch();
  sessionStorage.removeItem("RemindLater");
  sessionStorage.removeItem("RenwalIntercept");
  sessionStorage.removeItem("leuId");
  sessionStorage.removeItem("learnersintercept");
  sessionStorage.removeItem("isVocabCenter");
  sessionStorage.removeItem("isDemoUser");
  removeSingleCookie("isDemoUser");
  
  useEffect(() => {
        if(uId){
          dispatch(allActions.tosSessionInfoAction.getTosSessionInfo(uId, "6"));
        }
        removeSingleCookie(`${process.env.REACT_APP_ENV}IdToken`);
        window.location.href = `${process.env.REACT_APP_SSO_LOGIN_URL}`
  },[])

  return <PublicHome />

};

export default Logout;
